/**
 * CfssTimesheetApprovalPage — CFSS timesheet approval for all roles
 *
 * Backend filters timesheets based on caller's subject_filter:
 * - Responsible Party: sees workers serving participants they REPRESENT
 * - Participant: sees workers who SERVE them
 * - QP: sees all workers in their scope
 * - Agency Admin: sees all timesheets (no filter)
 *
 * MN 256B.85: CFSS participant-directed services
 * Thin wrapper around shared TimesheetApprovalPage with CFSS config.
 *
 * Route: /cfss/timesheets
 */

import { TimesheetApprovalPage } from '@/pages/shared-services';

export function CfssTimesheetApprovalPage() {
  return (
    <TimesheetApprovalPage
      title="Timesheet Approval"
      subtitle="Review and approve timesheets for your workers"
      workerLabel="Worker"
      scope="payroll:time:approve"
    />
  );
}

export default CfssTimesheetApprovalPage;
